module.exports = __webpack_public_path__ + "img/newlogo-es.1d100826.png";